module.exports = __webpack_public_path__ + "static/media/img-play-l@2x.11682012.png";